import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faBan, faInfo, faExclamation, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./Toast.css";

const VISUALS = {
  success: { icon: faCheck, label: "Success" },
  error: { icon: faBan, label: "Error" },
  info: { icon: faInfo, label: "Information" },
  warning: { icon: faExclamation, label: "Warning" },
};

export default function Toast({ message, title, body, type = "info", onClose, duration = 4000 }) {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const headline = title || message;
  const visual = VISUALS[type] || VISUALS.info;

  return (
    <div className={`toast toast-${type}`} role="alert" aria-live="assertive">
      <div className="toast-icon" aria-hidden="true">
        <FontAwesomeIcon icon={visual.icon} />
      </div>
      <div className="toast-content">
        <span className="toast-title">{headline}</span>
        {body && <span className="toast-body">{body}</span>}
      </div>
      <button className="toast-close" onClick={onClose} aria-label="Close notification">
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  );
}
